<template>
  <form name="fcontact_">
    <input type="hidden" name="type" value="B" />
    <div v-if="closeModal" class="pop_contact">
      <div class="pop_contact_bg"></div>
      <div class="w1200">
        <div id="layer" class="pop_layer">
          <div class="layer_top">
            <h1>교육문의</h1>
            <a class="layer_close">
              <img
                @click="handleCloseModal"
                :src="require('@/assets/img/modal_img/layer_close.png')"
              />
            </a>
          </div>
          <div class="layer_con">
            <h2>
              B2B 교육 및 솔루션에 대한 문의를 남겨주시면 담당자가 확인 후
              <br />
              최대한 빠른 시간 내에 연락드리겠습니다.
            </h2>
            <p class="copy">
              (혹시 이미 교육을 받고 계신 학습자이신가요?
              <a
                href="http://carrotenglish.kr/phone/main_new/contact"
                target="_blank"
                >Click!</a
              >)
            </p>
            <div class="box_form">
              <p style="vertical-align: middle; line-height: 23px">
                회사명<br /><span>(기관명)</span>
              </p>
              <input
                type="text"
                name="company"
                v-model="inquiryData.company"
                class="txt"
              />
            </div>
            <div class="box_form">
              <p>담당자명</p>
              <input
                type="text"
                name="agent"
                v-model="inquiryData.manager"
                class="txt"
              />
            </div>
            <div class="box_form">
              <p>연락처</p>
              <input
                type="text"
                v-model="inquiryData.phone"
                class="txt2"
                name="phone"
              />
              <!-- &nbsp;&nbsp;-&nbsp;&nbsp; -->
              <!-- <input type="text" v-model="inquiryData.phone2" class="txt2" name="phone2" /> -->
              <!-- &nbsp;&nbsp;-&nbsp;&nbsp; -->
              <!-- <input type="text" v-model="inquiryData.phone3" class="txt2" name="phone3" /> -->
            </div>
            <div class="box_form">
              <p>이메일</p>
              <input
                type="text"
                class="txt"
                v-model="inquiryData.email"
                name="email"
              />
            </div>

            <textarea
              class="layer_textarea"
              v-model="inquiryData.contents"
              name="content"
            ></textarea
            ><br />
            <div class="check-container">
              <div class="check">
                <input
                  type="checkbox"
                  v-model="inquiryData.agree"
                  name="agree1"
                  value="Y"
                /><a class="pointer" @click="handleOpenInfo"
                  >개인정보 수집 및 이용</a
                >에 동의합니다.
              </div>
            </div>
            <div v-if="isShowInfo">
              <div class="termsWrap" style="display: " id="rawContact">
                <div class="terms_title">
                  <h5>개인정보 수집 및 이용</h5>
                  <a @click="handleOpenInfo">
                    <img src="../assets/img/modal_img/btn_check_close.png" />
                  </a>
                </div>
              </div>
              <div class="terms_summary" style="white-space: pre-line">
                개인정보 처리방침 ㈜캐럿글로벌(이하 “회사”라고 함)은
                개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망
                이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가
                지켜야할 관련 법령상의 개인정보보호 규정을 준수하고 있습니다.
                당사의 개인정보처리방침은 정부의 법률/지침 변경 혹은
                ㈜캐럿글로벌의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를
                개정/변경하는 경우 당사의 홈페이지에 변경사항을 즉시 게시하고
                있습니다. 본 개인정보처리방침의 목차는 아래와 같습니다. 1.
                수집하는 개인정보의 항목 및 수집방법 2. 개인정보의 수집 및
                이용목적 3. 개인정보의 보유 및 이용기간 4. 개인정보의 파기절차
                및 방법 5. 개인정보 6. 수집한 개인정보의 위탁 7. 이용자 및
                법정대리인의 권리와 그 행사방법 8. 개인정보 자동수집 장치의
                설치, 운영 및 그 거부에 관한 사항 9. 개인정보 위탁 현황 10.
                개인정보 관리 책임자 11. 고지의 의무 1. 수집하는 개인정보의 항목
                및 수집방법 ㈜캐럿글로벌은 서비스 문의 등을 위해 아래와 같은
                개인정보를 수집하고 있습니다. 가. 수집하는 개인정보 항목 1)
                서비스 문의 시 아래 항목을 수집합니다. - 필수항목: 회사명,
                담당자명, 연락처, 이메일, 문의사항 2) 서비스 이용과정이나 사업
                처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다. -
                웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보,
                결제기록 - 모바일 이용 시: 서비스 이용 기록, 접속 로그,
                기기고유번호(디바이스 아이디 또는 IMEI) 3) 고객 상담 시 서비스
                품질 향상을 위해 담당자 연결 후 통화내용이 녹음되어 아래와 같은
                정보들을 수집합니다. - 통화이력 및 녹음 파일 나. 수집방법 1)
                홈페이지를 통한 이벤트 응모, 전화, 팩스, 고객센터 문의 및 상담
                2) 생성정보 수집 툴을 통한 수집 2. 개인정보의 수집 및 이용목적
                ㈜캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다.
                ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
                콘텐츠 제공, 구매 및 요금 결제, 본인인증, 물품배송 또는 청구지
                등 발송 ο 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인
                식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사
                확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달 ο 마케팅 및
                광고에 활용 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성
                정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재,
                접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계 ο 기타
                가입횟수 제한, 분쟁조정을 위한 기록보존, 회원의 각종 합격유무
                확인 및 기타 통계자료 산출 3. 개인정보의 보유 및 이용기간 회사는
                원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를
                지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다. ο
                파기절차:회원님이 회원가입 등을 위해 입력하신 정보는 목적이
                달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부
                방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및
                이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로
                옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는
                이외의 다른 목적으로 이용되지 않습니다. ο 파기방법:전자적
                파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을
                사용하여 삭제합니다. ο 보유기간:이용계약에 따른 회원자격이
                유지되는 기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에
                의하여 보존할 필요가 있는 경우 ㈜캐럿글로벌은 아래와 같이 일정
                기간동안 회원정보를 보관합니다. 회원 및 비회원 통화 이력은 상담
                종료 후 30일동안 보관된 후 파기됩니다. 4. 개인정보의 파기절차 및
                방법 개인정보의 보유 및 이용기간은 다음과 같습니다. ο
                보유항목:수집항목과 같습니다. ο 보유근거:이용약관 및
                개인정보취급방침 ο 보유기간:이용계약에 따른 회원자격이 유지되는
                기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할
                필요가 있는 경우 ㈜캐럿글로벌은 아래와 같이 일정 기간동안
                회원정보를 보관합니다. 표시/광고에 관한 기록 : 6개월
                (전자상거래등에서의 소비자보호에 관한 법률) 계약 또는 청약철회
                등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
                대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의
                소비자보호에 관한 법률) 소비자의 불만 또는 분쟁처리에 관한 기록
                : 3년 (전자상거래등에서의 소비자보호에 관한 법률) 신용정보의
                수집/처리 및 이용 등에 관한 기록 : 3년 (전자상거래등에서의
                소비자보호에 관한 법률) 통신비밀보호법에 따른 통신사실확인자료
                3개월 5. 개인정보 ㈜캐럿글로벌은 이용자의 개인정보를 원칙적으로
                외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
                이용자들이 사전에 동의한 경우 - 법령의 규정에 의거하거나, 수사
                목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는
                경우 6. 수집한 개인정보의 위탁 ㈜캐럿글로벌은 고객님의 동의없이
                고객님의 정보를 외부 업체에 위탁하지 않습니다. 향후 그러한
                필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게
                통지하고 필요한 경우 사전 동의를 받도록 하겠습니다. 7. 이용자 및
                법정대리인의 권리와 그 행사방법 이용자 및 법정 대리인은 언제든지
                등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를
                조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.
                이용자 혹은 만 14세 미만 아동의 개인정보 조회를 위해서는
                ‘정보수정’ 을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭
                하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가
                가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로
                연락하시면 지체없이 조치하겠습니다. 귀하가 개인정보의 오류에
                대한 정정을 요청하신 경우에는 정정을 완료하기 전 까지 개인정보를
                이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자 에게
                이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여
                정정이 이루어지도록 하겠습니다. ㈜캐럿글로벌은 이용자 혹은 법정
                대리인의 요청에 의해 해지 또는 삭제된 개인정보는 ㈜캐럿글로벌이
                수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라
                처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
                있습니다. 8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에
                관한 사항 ㈜캐럿글로벌은 귀하의 정보를 수시로 저장하고 찾아내는
                '쿠키(cookie)' 등을 운용합니다. 쿠키란 ㈜캐럿글로벌의 웹사이트를
                운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은
                텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.
                ㈜캐럿글로벌은 다음과 같은 목적을 위해 쿠키를 사용합니다. 쿠키
                등 사용 목적 - 회원과 비회원의 접속 빈도나 방문 시간 등을 분석,
                이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여
                정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스
                제공 쿠키 설정 거부 방법 - 쿠키 설정을 거부하는 방법으로는
                회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든
                쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든
                쿠키의 저장을 거부할 수 있습니다. - 설정방법 예(인터넷
                익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 >
                개인정보 (단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에
                어려움이 있을 수 있습니다.) 9. 개인정보 위탁 현황 고객지원 및
                서비스 제공을 위해 아래와 같이 개인정보 취급 업무를 외부 업체에
                위탁하여 운영하고 있습니다. 위탁계약시 개인정보보호의 안전을
                기하기 위하여 개인정보보호 관련 지시 엄수, 개인정보에 관한
                유출금지 및 사고시의 책임부담 등을 명확히 규정하고 위탁계약
                내용에 포함하고 있습니다. 수탁업체 위탁목적 ㈜다우기술 SMS
                발송대행 10. 개인정보 관리 책임자 ㈜캐럿글로벌은 고객의
                개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여
                아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.
                개인정보관리책임자 성명 : 이은경 본부장 전화번호 : 02-518-5467
                (평일 : 9시 ~ 6시까지) 이메일 : ashleylee@carrotglobal.com 기타
                개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에
                문의 가능합니다. • 개인정보침해신고센터 (privacy.kisa.or.kr /
                국번없이 118) • 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이
                1301) • 경찰청 사이버수사국 (police.go.kr / 국번없이 182) 11.
                고지의 의무 현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을
                시에는 변경사항 시행일의 7일전부터 홈페이지를 통해 고지할
                것입니다. - 공고일자: 2021년 5월 26일 - 시행일자: 2021년 6월 2일
              </div>
            </div>

            <a @click="saveInquiry" class="layer_ok pointer">확인</a>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      closeModal: true,
      isShowInfo: false,
      inquiryData: {
        company: "", //고객사명
        manager: "", //담당자
        email: "", //이메일
        contents: "", //내용
        category: "inbound",
        agree: false,
        phone: "", //연락처
        // phone2: "", //중간자리
        // phone3: "", //뒷자리
      },
    };
  },
  methods: {
    handleCloseModal() {
      this.closeModal = !this.closeModal;
    },
    saveInquiry() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone1" && !this.inquiryData[key]) {
          alert("연락처 앞자리 를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("내용을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (!flag) {
        this.axios
          .post(
            `/rest/external/addSMP?category=INBOUND&company=${this.inquiryData.company}&manager=${this.inquiryData.manager}&phone=${this.inquiryData.phone}&email=${this.inquiryData.email}&contents=${this.inquiryData.contents}&agree=${this.inquiryData.agree}`
          )
          .then((res) => {
            console.log(res);
            alert("문의가 완료되었습니다.");
            this.inquiryData = {
              company: "", //고객사명
              manager: "", //담당자
              email: "", //이메일
              contents: "", //내용
              category: "inbound",
              agree: false,
              phone: "", //앞자리
              // phone2: "", //중간자리
              // phone3: "", //뒷자리
            };
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
    handleOpenInfo() {
      this.isShowInfo = !this.isShowInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
@charset "utf-8";

@media screen and (max-width: 1200px) {
  .w1200 {
    width: 100%;
  }

  .top_bg .util_menu {
    padding-left: 20px;
    padding-right: 20px;
  }
  .top_bg .gnb {
    padding-left: 20px;
    padding-right: 20px;
  }
  .top_bg .gnb > ul > li {
    margin: 0 10px;
  }
  .top_bg .gnb > ul > li:after {
    right: -10px;
  }
  .top_bg .gnb > ul > li > a {
    font-size: 13px;
  }
  .top_bg .visual {
    padding-left: 20px;
    padding-right: 20px;
  }
  .top_bg .spec > li {
    display: inline-block;
    margin: 0 30px;
  }
  .top_bg .spec > li > .title {
    font-size: 40px;
  }
  .top_bg .spec > li > .copy {
    font-size: 20px;
  }

  .estimate2 .w1200 {
    padding: 0 20px;
  }
}

@media screen and (max-width: 1180px) {
  .w1200_2 {
    width: 90%;
    margin: auto;
  }
  .w_img {
    display: none;
  }
  .m_img {
    display: block;
    margin: 0;
    margin: 0 0 40px 0 !important;
  }

  /*서브_공통*/
  .sub_con h2 {
    font-size: 35px;
    line-height: 45px;
    font-weight: bold;
    padding-top: 80px;
    text-align: center;
  }
  .bar {
    width: 85%;
  }
  .sub_pdf_down {
    margin: auto;
  }
  .sub_pdf_down2 {
    margin: auto;
  }
  .sub_pdf_down3 {
    margin: auto;
    margin-top: 10px;
    margin-left: 20px;
  }
  .sub_con1 {
    clear: both;
    text-align: center;
    padding-top: 110px;
  }
  .sub_con1 .sub_con_img {
    float: none;
    padding-right: 0px;
    margin: 40px 0 0 0;
  }
  .sub_con1 .sub_con_img img {
    width: 100%;
    max-width: 565px;
  }

  .sub_con1 .text {
    width: 100%;
    float: none;
    margin: 60px 0;
  }
  .sub_con1 .text ul li {
    background: none;
  }

  .sub_con2 {
    padding: 100px 0;
    text-align: center;
  }
  .sub_con2 .text {
    float: left;
  }
  .sub_con2 .sub_con_img {
    margin: 40px 0 0 0;
    text-align: center;
    padding-left: 0px;
  }
  .sub_con2 .sub_con_img img {
    width: 100%;
    max-width: 565px;
  }
  .sub_con2 .text {
    width: 100%;
    float: none;
  }
  .sub_con2 .text ul li {
    background: none;
  }

  .sub_con3 {
    padding: 100px 0 60px 0;
    text-align: center;
  }
  .sub_con3 .text {
    float: left;
  }
  .sub_con3 .sub_con_img {
    margin: 40px 0 0 0;
    text-align: center;
    padding-left: 0px;
  }
  .sub_con3 .sub_con_img img {
    width: 100%;
    max-width: 565px;
  }
  .sub_con3 .text {
    width: 100%;
    float: none;
  }
  .sub_con3 .text ul li {
    background: none;
  }
  .sub_con3 .text .text2 {
    border-top: 1px solid #f4f4f4;
    padding-top: 20px;
  }
  .sub_con3 .text .text2 li {
    background: none;
  }

  .sub_con4 {
    clear: both;
    text-align: center;
    padding-top: 150px;
  }
  .sub_con4 .sub_con_img {
    float: none;
    padding-right: 0px;
    margin: 40px 0 0 0;
  }
  .sub_con4 .sub_con_img img {
    width: 100%;
    max-width: 565px;
  }
  .sub_con4 .text {
    width: 100%;
    float: none;
    margin: 60px 0;
  }
  .sub_con4 .text ul li {
    background: none;
  }
  .sub_con4 .text ul li.book {
  }
  .sub_con4 .text ul li.book img {
    width: 100%;
  }
  .sub_con4 .text .text2 {
    border-top: 1px solid #f4f4f4;
    padding-top: 20px;
  }
  .sub_con4 .text .text2 li {
    background: none;
  }
}

@media screen and (max-width: 920px) {
  .m_gnb {
    position: absolute;
    top: 20px;
    right: 20px;
    display: block;
    width: 18px;
    height: 20px;
    font-size: 0;
    text-indent: -999px;
    overflow: hidden;
    background: url(../assets/img/modal_img/m_gnb.png) no-repeat left top;
    background-size: 100% auto;
  }
  .m_gnb_list {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 0;
    background: #2a2929;
  }
  .m_gnb_list h1 {
    overflow: hidden;
    padding: 0 18px;
  }
  .m_gnb_list h1 > img {
    float: left;
  }
  .m_gnb_list h1 > button {
    float: right;
    width: 21px;
    height: 21px;
    font-size: 0;
    text-indent: -999px;
    overflow: hidden;
    background: url(../assets/img/modal_img/menu_close.png) no-repeat left top;
    background-size: 21px auto;
  }
  .m_gnb_list ul {
    padding: 20px 22px 0 22px;
  }
  .m_gnb_list ul li > a {
    display: block;
    font-size: 15px;
    color: #fff;
    padding: 17px 0;
    border-bottom: 1px solid #5b5757;
  }
  .m_gnb_list ul li.util > a {
    padding: 12px 0;
    font-size: 12px;
    color: #706a66;
    border-bottom: 0;
  }

  .top_bg {
  }
  .top_bg .util_menu,
  .top_bg .gnb > ul {
    display: none;
  }
  .top_bg .gnb > h1 {
    padding: 20px 0;
  }

  .estimate2 .left_area {
    float: none;
    width: 100%;
  }
  .estimate2 .right_area {
    float: none;
    width: 100%;
    margin: 30px 0 0 0;
  }

  .customEX ul .customEX_con {
    display: block;
    line-height: 24px;
    width: auto;
  }
}

@media screen and (max-width: 900px) {
  * {
    font-family: "돋움", dotum, sans-serif;
    word-break: keep-all;
  }

  .top_area {
    padding-bottom: 50px;
  }
  .top_area .util_menu,
  .top_area .gnb > ul {
    display: none;
  }
  .top_area .gnb > h1 {
    padding: 20px 0;
  }

  .footer .contact .cs_list > li.tel a {
    font-size: 16px;
    color: #80898e;
  }
}

@media screen and (max-width: 700px) {
  .m_br {
    display: block;
  }
  .w_br {
    display: none;
  }

  .top_area {
    padding-bottom: 20px;
  }
  .footer .copyright {
    float: none;
    width: 90%;
    margin: 0 auto;
  }
  .footer .contact {
    float: none;
    width: 90%;
    margin: 40px auto 0 auto;
  }
  .sub_pdf_down3 {
    margin: auto;
    margin-top: 10px;
    margin-left: 0px;
  }

  .sub_con3 .text a:last-child {
    margin-top: 10px;
  }
}

@media screen and (max-width: 640px) {
  body {
    font-family: "돋움", dotum, sans-serif;
    font-weight: normal;
  }

  .top_bg {
    min-height: 0px;
    height: 440px;
  }

  .sub_top .title {
    padding-top: 20px;
  }
  .sub_top .title span {
    display: none;
  }
  .sub_top .sub_copy {
    font-size: 18px;
    line-height: 25px;
    font-weight: normal;
    padding-top: 20px;
    color: #fff;
  }

  .sub_bar {
    margin: 30px 0;
  }

  .sub_con1 {
    padding-top: 80px;
  }
  .sub_con1 .text {
    margin-top: 30px;
  }
  .sub_con1 h3 {
    font-size: 33px;
    line-height: 40px;
  }
  .sub_con1 h4 {
    font-size: 23px;
    line-height: 30px;
  }
  .sub_con1 .sub_con_img {
    margin-top: 0;
  }

  .sub_con2 {
    padding: 30px 0 80px 0;
  }
  .sub_con2 .text {
    margin-top: 30px;
  }
  .sub_con2 h3 {
    font-size: 33px;
    line-height: 40px;
  }
  .sub_con2 h4 {
    font-size: 23px;
    line-height: 30px;
  }

  .sub_con3 {
    padding-top: 108px;
  }
  .sub_con3 .text {
    margin-top: 30px;
  }
  .sub_con3 h3 {
    font-size: 33px;
    line-height: 40px;
  }
  .sub_con3 h4 {
    font-size: 23px;
    line-height: 30px;
  }

  .sub_con4 {
    padding-top: 82px;
  }
  .sub_con4 .text {
    margin-top: 30px;
  }
  .sub_con4 h3 {
    font-size: 33px;
    line-height: 40px;
  }
  .sub_con4 h4 {
    font-size: 23px;
    line-height: 30px;
  }

  .estimate2 .title {
    font-size: 33px;
  }
  .estimate2 .copy {
    font-size: 18px;
    line-height: 23px;
    padding: 15px 0;
  }
  .estimate2 .left_area > li > label,
  .estimate2 .right_area > label {
    font-size: 16px;
    height: 23px;
    line-height: 24px;
  }
  .estimate2 .left_area > li > input[type="text"],
  .estimate2 .left_area > li > input[type="email"] {
    height: 24px;
  }
  .estimate2 .left_area > li > input[type="num"] {
    height: 24px;
  }
  .estimate2 .left_area > li > span {
    height: 24px;
    line-height: 24px;
  }
}
/* html 엘리먼트 속성 초기화 */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 1em;
  margin: 0px;
}
p,
ul,
ol,
li,
dl,
dt,
dd,
form,
fieldset {
  margin: 0px;
  padding: 0px;
  font-size: 100%;
}
ul,
ol,
li {
  list-style: none;
  font-size: 100%;
}
table {
  border-collapse: collapse;
  font-size: 100%;
}
legend {
  visibility: hidden;
  overflow: hidden;
  width: 0;
  height: 0;
  background-color: transparent;
  font-size: 0;
  line-height: 0;
}
caption {
  visibility: hidden;
  overflow: hidden;
  width: 0;
  height: 0;
  background-color: transparent;
  font-size: 0;
  line-height: 0;
  text-indent: -9999em;
}
img {
  border: 0 none;
  font-size: 0px;
  line-height: 0px;
  vertical-align: top;
}
input,
select,
textarea {
  margin: 0px;
  padding: 0px;
}

html {
  width: 100%;
}
html,
body {
  -webkit-overflow-scrolling: touch;
}
body {
  position: relative;
  overflow-x: hidden;
}
button {
  background: transparent;
  border: 0;
  padding: 0;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* 그외 초기화 */
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
header,
hgroup,
footer,
nav,
section,
article,
aside,
figure,
video,
audio {
  margin: 0;
  padding: 0;
  border: 0;
}
em,
address {
  font-style: normal;
}
hr {
  display: none;
}

select,
textarea,
input,
label,
img,
button {
  vertical-align: middle;
}
table td {
  word-wrap: break-word;
  word-break: break-all;
}
button {
  cursor: pointer;
}

/** common style **/
/* font n color */
body,
input,
select,
textarea,
a,
button {
  line-height: 1;
  font-family: "Noto Sans", "맑은고딕", "Malgun Gothic", "돋움", Dotum,
    Helvetica, AppleGothic, sans-serif;
  font-size: 13px;
  color: #232323;
  letter-spacing: -1px;
}

a,
a:hover,
a.on,
a.active {
  text-decoration: none;
}

.blind {
  display: none;
}

.f_left {
  float: left !important;
}
.f_right {
  float: right !important;
}
.t_left {
  text-align: left !important;
}
.t_center {
  text-align: center !important;
}
.t_right {
  text-align: right !important;
}
.clear {
  clear: both !important;
}
.o_flow {
  overflow: hidden !important;
}
.bold {
  font-weight: bold;
}

.font12 {
  font-size: 12px !important;
}
.font13 {
  font-size: 13px !important;
}
.font14 {
  font-size: 14px !important;
}
.font15 {
  font-size: 15px !important;
}
.font16 {
  font-size: 16px !important;
}
.font17 {
  font-size: 17px !important;
}
.font18 {
  font-size: 18px !important;
}
.font19 {
  font-size: 19px !important;
}
.font20 {
  font-size: 20px !important;
}
.font24 {
  font-size: 24px !important;
}
.font30 {
  font-size: 30px !important;
}
.font36 {
  font-size: 36px !important;
}
.font40 {
  font-size: 40px !important;
}

.mgt0 {
  margin-top: 0px !important;
}
.mgt5 {
  margin-top: 5px !important;
}
.mgt6 {
  margin-top: 6px !important;
}
.mgt7 {
  margin-top: 7px !important;
}
.mgt8 {
  margin-top: 8px !important;
}
.mgt9 {
  margin-top: 9px !important;
}
.mgt10 {
  margin-top: 10px !important;
}
.mgt11 {
  margin-top: 11px !important;
}
.mgt15 {
  margin-top: 15px !important;
}
.mgt20 {
  margin-top: 20px !important;
}
.mgt25 {
  margin-top: 25px !important;
}
.mgt30 {
  margin-top: 30px !important;
}
.mgt40 {
  margin-top: 40px !important;
}
.mgt50 {
  margin-top: 50px !important;
}
.mgt60 {
  margin-top: 60px !important;
}
.mgt80 {
  margin-top: 80px !important;
}
.mgt100 {
  margin-top: 100px !important;
}
.mgt120 {
  margin-top: 120px !important;
}

.mgb0 {
  margin-bottom: 0px !important;
}
.mgb10 {
  margin-bottom: 10px !important;
}
.mgb20 {
  margin-bottom: 20px !important;
}
.mgb30 {
  margin-bottom: 30px !important;
}
.mgb40 {
  margin-bottom: 40px !important;
}
.mgb50 {
  margin-bottom: 50px !important;
}
.mgb80 {
  margin-bottom: 80px !important;
}
.mgb100 {
  margin-bottom: 100px !important;
}

.mgl5 {
  margin-left: 5px !important;
}
.mgl10 {
  margin-left: 10px !important;
}
.mgl20 {
  margin-left: 20px !important;
}
.mgl30 {
  margin-left: 30px !important;
}
.mgl40 {
  margin-left: 40px !important;
}

.pdt0 {
  padding-top: 0px !important;
}
.pdt10 {
  padding-top: 10px !important;
}
.pdt20 {
  padding-top: 20px !important;
}
.pdt30 {
  padding-top: 30px !important;
}
.pdt40 {
  padding-top: 40px !important;
}

.pdr0 {
  padding-right: 0px !important;
}
.pdr10 {
  padding-right: 10px !important;
}
.pdr20 {
  padding-right: 20px !important;
}
.pdr30 {
  padding-right: 30px !important;
}
.pdr40 {
  padding-right: 40px !important;
}

.pdl0 {
  padding-left: 0px !important;
}
.pdl10 {
  padding-left: 10px !important;
}
.pdl20 {
  padding-left: 20px !important;
}
.pdl30 {
  padding-left: 30px !important;
}
.pdl40 {
  padding-left: 40px !important;
}

.pdb0 {
  padding-bottom: 0px !important;
}
.pdb10 {
  padding-bottom: 10px !important;
}
.pdb20 {
  padding-bottom: 20px !important;
}
.pdb30 {
  padding-bottom: 30px !important;
}
.pdb40 {
  padding-bottom: 40px !important;
}
.pdb50 {
  padding-bottom: 50px !important;
}
.pdb60 {
  padding-bottom: 60px !important;
}
.pdb100 {
  padding-bottom: 100px !important;
}

.noLine {
  border: none !important;
}
.noBg {
  background: none !important;
}

body {
  word-break: keep-all;
}

.w1200 {
  display: flex;
  justify-content: center;
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.w1200_2 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.m_br {
  display: none;
}

/* 메인 탑 */
.top_bg {
  min-height: 412px;
  background: url(../assets/img/modal_img/sub_main.jpg) no-repeat center top;
}
.top_bg .util_menu {
  padding: 24px 0;
  text-align: right;
  font-size: 0;
}
.top_bg .util_menu > li {
  display: inline-block;
  margin: 0 0 0 28px;
}
.top_bg .util_menu > li > a {
  font-size: 13px;
  color: #fff;
}

.top_bg .gnb:after {
  content: "";
  height: 0;
  display: block;
  clear: both;
  visibility: hidden;
}
.top_bg .gnb > h1 {
  float: left;
}
.top_bg .gnb > ul {
  float: right;
  margin: 8px 0;
  font-size: 0;
}
.top_bg .gnb > ul > li {
  position: relative;
  display: inline-block;
  margin: 0 10px;
}
/* .top_bg .gnb > ul > li:after{content:"";position:absolute;top:0;right:-20px;width:1px;height:100%;background:#fff;} */
.top_bg .gnb > ul > li:last-child {
  margin-right: 0;
}
.top_bg .gnb > ul > li:last-child:after {
  content: none;
}
.top_bg .gnb > ul > li > a {
  font-size: 14px;
  color: #fff;
}
.m_gnb,
.m_gnb_list {
  display: none;
}

.w_img {
  display: block;
}
.m_img {
  display: none;
}

.btn_sub_contact {
  color: #ffffff;
  border: 1px solid #ffffff;
  font-weight: bold;
  padding: 11px 20px;
  display: inline-block;
  margin: 24px 0 0 0;
  font-size: 16px;
}

.lang {
  background: #618942;
  color: #ffffff;
  border: none;
  vertical-align: baseline;
  padding: 0;
}

/*서브_공통*/
.sub_top {
  text-align: center;
}
.title {
  font-size: 45px;
  line-height: 60px;
  font-weight: bold;
  color: #fff;
  padding-top: 50px;
}
.sub_copy {
  font-size: 22px;
  line-height: 35px;
  font-weight: normal;
  padding-top: 20px;
  color: #fff;
}

.sub_bar {
  width: 73px;
  border-top: 1px solid #000;
  margin: 40px 0;
  display: inline-block;
}

.sub_pdf_down {
  display: block;
  width: 280px;
  border: 1px solid #1fafcd;
  font-size: 16px;
  font-weight: bold;
  color: #1fafcd;
  text-align: center;
  position: relative;
  padding: 20px 50px;
  overflow: hidden;
  text-transform: uppercase;
}
.sub_pdf_down span {
  position: relative;
  transition: color 0.25s ease-out;
  -webkit-transition: color 0.5s ease-out;
  -moz-transition: color 0.5s ease-out;
}
.sub_pdf_down:hover span {
  color: #fff;
  border: none;
}
.sub_pdf_down .pdf_hover {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #8cc641 0%, #1fafcd 100%);
  border: 1px solid transparent;
  transform: scale(1, 0);
  -webkit-transform: scale(1, 0);
  -moz-transform: scale(1, 0);
  -ms-transform: scale(1, 0);
  transform-origin: center top;
  -webkit-transform-origin: center top;
  -moz-transform-origin: center top;
  -ms-transform-origin: center top;
  transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  border: none;
}
.sub_pdf_down:hover .pdf_hover {
  transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  border: none;
}

.sub_pdf_down2 {
  display: inline-block;
  width: 280px;
  border: 1px solid #1fafcd;
  font-size: 16px;
  font-weight: bold;
  color: #1fafcd;
  text-align: center;
  padding: 20px 50px;
  margin-top: 80px;
  position: relative;
  overflow: hidden;
}
.sub_pdf_down2 span {
  position: relative;
  transition: color 0.25s ease-out;
  -webkit-transition: color 0.5s ease-out;
  -moz-transition: color 0.5s ease-out;
}
.sub_pdf_down2:hover span {
  color: #fff;
  border: none;
}
.sub_pdf_down2 .pdf_hover {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #8cc641 0%, #1fafcd 100%);
  border: 1px solid transparent;
  transform: scale(1, 0);
  -webkit-transform: scale(1, 0);
  -moz-transform: scale(1, 0);
  -ms-transform: scale(1, 0);
  transform-origin: center top;
  -webkit-transform-origin: center top;
  -moz-transform-origin: center top;
  -ms-transform-origin: center top;
  transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  border: none;
}
.sub_pdf_down2:hover .pdf_hover {
  transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  border: none;
}

.sub_pdf_down3 {
  display: inline-block;
  width: 280px;
  border: 1px solid #ff3871;
  font-size: 16px;
  font-weight: bold;
  color: #ff3871;
  text-align: center;
  padding: 20px 20px;
  margin-top: 80px;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  margin-left: 10px;
}
.sub_pdf_down3 span {
  position: relative;
  transition: color 0.25s ease-out;
  -webkit-transition: color 0.5s ease-out;
  -moz-transition: color 0.5s ease-out;
}
.sub_pdf_down3:hover span {
  color: #fff;
  border: none;
}
.sub_pdf_down3 .pdf_hover {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #ff3871 0%, #ff7d1d 100%);
  border: 1px solid transparent;
  transform: scale(1, 0);
  -webkit-transform: scale(1, 0);
  -moz-transform: scale(1, 0);
  -ms-transform: scale(1, 0);
  transform-origin: center top;
  -webkit-transform-origin: center top;
  -moz-transform-origin: center top;
  -ms-transform-origin: center top;
  transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  border: none;
}
.sub_pdf_down3:hover .pdf_hover {
  transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  border: none;
}

.sub_con1 {
  clear: both;
  padding-top: 65px;
}
.sub_con1 .sub_con_img {
  float: left;
  padding-right: 38px;
  margin: 100px 0;
}
.sub_con1 h3 {
  font-size: 25px;
  font-weight: bold;
  line-height: 35px;
}
.sub_con1 h4 {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  padding-bottom: 25px;
}
.sub_con1 .text {
  width: 49%;
  float: left;
  margin-top: 100px;
}
.sub_con1 .text ul {
  padding-bottom: 23px;
}
.sub_con1 .text ul li {
  font-size: 16px;
  color: #707070;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list.jpg) no-repeat left 12px;
  padding-left: 10px;
}

.sub_con2 {
  clear: both;
  background: #f7f7f7;
  padding: 100px 0;
}
.sub_con2 .text {
  float: left;
}
.sub_con2 .sub_con_img {
  text-align: right;
  padding-left: 38px;
}
.sub_con2 h3 {
  font-size: 25px;
  font-weight: bold;
  line-height: 35px;
}
.sub_con2 h4 {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  padding-bottom: 25px;
}
.sub_con2 .text {
  width: 49%;
  float: left;
}
.sub_con2 .text ul {
  padding-bottom: 23px;
}
.sub_con2 .text ul li {
  font-size: 16px;
  color: #707070;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list.jpg) no-repeat left 12px;
  padding-left: 10px;
}

.sub_con3 {
  clear: both;
  padding: 200px 0 100px 0;
}
.bar {
  width: 100%;
  max-width: 1200px;
  border-bottom: 1px solid #d8d8d8;
  margin: auto;
}
.sub_con3 .text {
  float: left;
}
.sub_con3 ul {
  overflow: hidden;
}
.sub_con3 .sub_con_img {
  text-align: right;
  padding-right: 38px;
  float: left;
}
.sub_con3 h3 {
  font-size: 25px;
  font-weight: bold;
  line-height: 35px;
}
.sub_con3 h4 {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  padding-bottom: 25px;
}
.sub_con3 .text {
  width: 49%;
  float: left;
  margin-top: 70px;
}
.sub_con3 .text ul {
  padding-bottom: 23px;
}
.sub_con3 .text ul li {
  font-size: 16px;
  color: #707070;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list.jpg) no-repeat left 15px;
  padding-left: 10px;
}
.sub_con3 .text .text2 li {
  font-size: 16px;
  color: #000;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list2.jpg) no-repeat left center;
  padding-left: 10px;
}
.sub_con3 .text .text2 li span {
  font-weight: bold;
}

.sub_con4 {
  clear: both;
  padding-top: 100px;
}
.sub_con4 .sub_con_img {
  float: left;
  padding-right: 38px;
  margin: 100px 0;
}
.sub_con4 h3 {
  font-size: 25px;
  font-weight: bold;
  line-height: 35px;
}
.sub_con4 h4 {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  padding-bottom: 25px;
}
.sub_con4 .text {
  width: 49%;
  float: left;
  margin-top: 100px;
}
.sub_con4 .text ul {
  padding-bottom: 23px;
}
.sub_con4 .text ul li {
  font-size: 16px;
  color: #707070;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list.jpg) no-repeat left 15px;
  padding-left: 10px;
}
.sub_con4 .text ul li.book {
  margin-top: 50px;
  background: none;
}
.sub_con4 .text ul li span {
  font-weight: bold;
}
.sub_con4 .text ul .li_dd {
  font-size: 16px;
  color: #707070;
  line-height: 26px;
  background: none;
  padding-left: 10px;
}
.sub_con4 .text .text2 li {
  font-size: 16px;
  color: #000;
  line-height: 26px;
  background: url(../assets/img/modal_img/sub_list2.jpg) no-repeat left center;
  padding-left: 10px;
}
.sub_con4 .text .text2 li span {
  font-weight: bold;
}

/*맞춤개발*/
.customEX {
  clear: both;
  font-size: 16px;
  padding: 80px 0;
  text-align: center;
  margin: 0 auto;
}
.customEX h4 {
  padding-bottom: 80px;
  font-size: 22px;
}
.customEX ul {
  padding-bottom: 30px;
}
.customEX ul .customEX_con {
  display: inline-flex;
  line-height: 24px;
  width: 30%;
}
.customEX ul .customEX_con:last-child {
  padding-right: 0px;
}
.customEX ul .customEX_con ul {
  margin: 0 auto;
}
.customEX ul .customEX_con dl {
  padding-top: 20px;
}
.customEX ul .customEX_con dl dd {
  padding-top: 10px;
}
.customEX ul .customEX_con dl dd span {
  font-weight: bold;
}

/*교육문의_web*/
.pop_contact {
  position: absolute;
  top: 100px;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.pop_contact .pop_contact_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.pop_contact .pop_layer {
  display: block;
  position: relative;
  width: 575px;
  height: auto;
  background-color: #fff;
  margin-top: 10%;
}

.layer_top {
  width: 100%;
  padding: 30px 40px;
  background: #8cc641;
  background: linear-gradient(to right, #8cc641 0%, #1fafcd 100%);
}
.layer_top h1 {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  display: inline-block;
}
.layer_close {
  float: right;
  margin-top: -3px;
}
.layer_con {
  padding: 20px 40px 40px 40px;
}
.layer_con h2 {
  font-size: 17px;
  line-height: 28px;
  padding-bottom: 10px;
}
.layer_con .copy {
  font-size: 16px;
  padding-bottom: 40px;
  color: #000;
}
.layer_con .copy a {
  font-size: 16px;
  color: #2196f3;
}
.box_form {
  font-size: 15px;
  margin-bottom: 20px;
}
.box_form p {
  display: inline-block;
  width: 15%;
}
.box_form .txt {
  width: 85%;
  padding: 0 15px;
  height: 40px;
  border: 1px solid #dadada;
}
.box_form .txt2 {
  width: 85%;
  padding: 0 15px;
  height: 40px;
  border: 1px solid #dadada;
}
.check {
  display: contents;
  padding-top: 10px;
  padding-bottom: 20px;
}
.check a {
  text-decoration: underline;
}
.layer_textarea {
  border: 1px solid #dadada;
  padding: 15px 15px;
  width: 100%;
  height: 150px;
  line-height: 20px;
}
.check-container {
  margin: 10px 0 20px 0;
}
.layer_ok {
  margin-top: 10px;
  font-size: 15px;
  text-align: right;
  padding-top: 0px;
  font-weight: bold;
  float: right;
  padding-bottom: 40px;
  color: #ff416d;
}

.termsWrap {
  margin: 0px 0 0 0px;
  background: #f7f7f7;
}
.terms_title {
  position: relative;
  padding: 5px 10px;
  background: #e4e4e4;
}
.terms_title h5 {
  font-size: 12px;
  font-weight: bold;
}
.terms_title a {
  position: absolute;
  top: 3px;
  right: 10px;
}
.terms_summary {
  height: 50px;
  overflow-y: scroll;
  font-size: 11px;
  padding: 10px;
  line-height: 16px;
}

/*교육문의_mobile*/
.pop_top {
  width: 100%;
  padding: 30px 30px;
  background: linear-gradient(to right, #8cc641 0%, #1fafcd 100%);
}
.pop_top h1 {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  display: inline-block;
}
.pop_con {
  padding: 20px 30px 40px 30px;
}
.pop_con h2 {
  font-size: 18px;
  line-height: 28px;
  padding-bottom: 20px;
}
.pop_con .copy {
  font-size: 16px;
  padding-bottom: 40px;
  color: #000;
}
.pop_con .copy a {
  font-size: 16px;
  color: #2196f3;
}
.m_box_form {
  font-size: 15px;
  margin-bottom: 20px;
}
.m_box_form p {
  display: inline-block;
  width: 20%;
}
.m_box_form .txt {
  width: 75%;
  padding: 0 15px;
  height: 40px;
  border: 1px solid #dadada;
}
.m_box_form .txt2 {
  width: 21%;
  padding: 0 11px;
  height: 40px;
  border: 1px solid #dadada;
}
.m_check {
  padding-top: 10px;
  padding-bottom: 20px;
}
.m_check a {
  text-decoration: underline;
}
.pop_textarea {
  border: 1px solid #dadada;
  padding: 15px 15px;
  width: 100%;
  height: 200px;
  line-height: 20px;
}
.pop_ok {
  font-size: 15px;
  text-align: right;
  padding-top: 20px;
  font-weight: bold;
  float: right;
  color: #ff416d;
}
.pop_con {
  margin-bottom: 50px;
}

.m_termsWrap {
  margin: 0px 0 20px 0px;
  background: #f7f7f7;
}
.m_terms_title {
  position: relative;
  padding: 5px 10px;
  background: #e4e4e4;
}
.m_terms_title h5 {
  font-size: 12px;
  font-weight: bold;
}
.m_terms_title a {
  position: absolute;
  top: 7px;
  right: 10px;
}
.m_terms_summary {
  height: 50px;
  overflow-y: scroll;
  font-size: 11px;
  padding: 10px;
  line-height: 16px;
}

/* 문의하기 */
.estimate2 {
  padding: 10px 0 70px 0;
  clear: both;
  background: #7a8086;
}
.estimate2 .title {
  font-size: 50px;
  color: #fff;
}
.estimate2 .copy {
  display: block;
  padding: 36px 0 10px 0;
  font-size: 20px;
  color: #fff;
}
.estimate2 .copy2 {
  font-size: 16px;
  padding-bottom: 40px;
  color: #fff;
}
.estimate2 .copy2 a {
  font-size: 16px;
  color: #8ecdff;
}
.estimate2 .formarea:after {
  content: "";
  height: 0;
  display: block;
  clear: both;
  visibility: hidden;
}
.estimate2 .left_area {
  float: left;
  width: 50%;
}
.estimate2 .left_area > li {
  overflow: hidden;
  margin-bottom: 14px;
}
.estimate2 .left_area > li > label {
  float: left;
  width: 25%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #fff;
}
.estimate2 .left_area > li > input[type="text"],
.estimate2 .left_area > li > input[type="email"] {
  float: left;
  width: 75%;
  height: 40px;
  border: 1px solid #dadada;
  padding: 0 10px;
}
.estimate2 .left_area > li > input[type="num"] {
  float: left;
  width: 24%;
  height: 40px;
  border: 1px solid #dadada;
}
.estimate2 .left_area > li > span {
  float: left;
  width: 1.5%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
}
.estimate2 .right_area {
  float: right;
  width: 45%;
}
.estimate2 .right_area > label {
  display: block;
  font-size: 18px;
  color: #fff;
}
.estimate2 .right_area > textarea {
  width: 100%;
  height: 168px;
  margin: 18px 0 0 0;
  border: 1px solid #dadada;
  margin-bottom: 20px;
  padding: 10px 10px;
  line-height: 20px;
}
.estimate2 .right_area .checkbox {
  display: inline-block;
}
.estimate2 .right_area .checkbox_p {
  display: inline-block;
  font-size: 14px;
}
.estimate2 .right_area .checkbox_p a {
  font-size: 14px;
  text-decoration: underline;
  color: #fff;
}
.estimate2 .btn_group {
  text-align: right;
}
.estimate2 .btn_ok {
  position: relative;
  display: inline-block;
  margin: 40px 0 0 0;
  color: #81feff;
  font-size: 16px;
}
.estimate2 .btn_ok:after {
}

.estimate2 .termsWrap {
  margin: 20px 0 0px 0px;
  background: #f7f7f7;
}
.estimate2 .terms_title {
  position: relative;
  padding: 5px 10px;
  background: #e4e4e4;
}
.estimate2 .terms_title h5 {
  font-size: 12px;
  font-weight: bold;
}
.estimate2 .terms_title a {
  position: absolute;
  top: 7px;
  right: 10px;
}
.estimate2 .terms_summary {
  height: 50px;
  overflow-y: scroll;
  font-size: 11px;
  padding: 10px;
}

/*FAQ*/

.faqWrap {
  width: 1200px;
  margin: 0 auto;
  padding: 0;
}
.faqWrap ul {
  margin: 0px 0 42px 0;
  padding: 0 0 20px 0;
  border-bottom: 1px dashed #c7c7c7;
}
.faqWrap ul:last-child {
  border-bottom: none;
}
.faqWrap h3 {
  font-size: 25px;
  font-weight: normal;
  padding: 0 0 20px 0;
}
.faqWrap h4 {
  font-size: 16px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.faqWrap li {
  font-size: 14px;
  font-weight: normal;
  padding: 0 0 20px 0;
  line-height: 25px;
}
.faqWrap li span {
  font-size: 14px;
  color: #dc2d60;
}

/* 푸터 */
.footer {
  overflow: hidden;
  padding: 50px 0;
  background: #3f484f;
  color: #80898e;
  clear: both;
}
.footer .copyright {
  float: left;
  width: 48%;
}
.footer .copyright > p {
  font-size: 15px;
  line-height: 22px;
}
.footer .copyright .f_menu {
  margin: 25px 0;
  overflow: hidden;
}
.footer .copyright .f_menu > li {
  float: left;
  position: relative;
  margin: 5px 24px 5px 0;
}
.footer .copyright .f_menu > li:after {
  content: "";
  position: absolute;
  top: 0;
  right: -12px;
  width: 1px;
  height: 100%;
  background: #80898e;
}
.footer .copyright .f_menu > li:last-child:after {
  content: none;
}
.footer .copyright .f_menu > li > a {
  font-size: 15px;
  color: #80898e;
}
.footer .copyright .social {
  overflow: hidden;
}
.footer .copyright .social > dt {
  float: left;
  height: 26px;
  line-height: 26px;
  font-weight: bold;
  letter-spacing: 0;
}
.footer .copyright .social > dd {
  float: left;
  margin: 0 5px;
}

.footer .contact {
  float: right;
  width: 48%;
}
.footer .contact .title {
  overflow: hidden;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #80898e;
}
.footer .contact .title > strong {
  float: left;
  padding: 4px 0 0 0;
  font-size: 18px;
  letter-spacing: 0;
}
.footer .contact .title > select {
  float: right;
  border: 0;
  padding: 4px 10px;
}
.footer .contact .cs_list {
  padding: 26px 0 0 0;
}
.footer .contact .cs_list > li {
  margin: 0 0 20px 0;
  padding: 0 0 0 36px;
  background-repeat: no-repeat;
  background-position: left center;
  font-size: 18px;
}
.footer .contact .cs_list > li.tel {
  background-image: url(../assets/img/modal_img/ico_tel.png);
}
.footer .contact .cs_list > li.mail {
  background-image: url(../assets/img/modal_img/ico_mail.png);
}

.footer .contact .cs_list > li.tel a {
  font-size: 18px;
  color: #80898e;
}
</style>
